import React, { useState } from "react";
import Header from "../../../components/Header";
import LeftMenu from "../../../components/LeftMenu";
import SplitScreenSelector from "./components/SplitScreenSelector";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight, faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { faPen } from "@fortawesome/free-solid-svg-icons";

/*
  STATUS COLOURS
*/
function getStatusStyle(status) {
  switch (status) {
    case "On Track":
      return { backgroundColor: "#1f8f4a" };
    case "At Risk":
      return { backgroundColor: "#c98a00" };
    case "Delayed":
      return { backgroundColor: "#b83232" };
    case "Completed":
      return { backgroundColor: "#2f6fb3" };
    default:
      return { backgroundColor: "#666" };
  }
}

export default function ProjectsHome() {

  var [expandedProjectIds, setExpandedProjectIds] = useState([]);
  var [showIssuesDrawer, setShowIssuesDrawer] = useState(false);
  var [activeProject, setActiveProject] = useState(null);

  /*
    MOCK DATA (PoC)
  */
  var projects = [
    {
      id: 1,
      name: "HQ Consolidation",
      sponsor: "Jane Smith",
      company: "ACME Appliances",
      status: "On Track",
      people: 120,
      desks: 110,
      assets: 420,
      completionDate: "30 Jun 2025",
      moves: [
        {
          id: 101,
          name: "Phase 1 – Finance",
          divisions: "Finance",
          fromTo: "Building A → Building C",
          contractor: "Pickfords",
          people: 40,
          desks: 38,
          assets: 140,
          date: "12 May 2025",
          readiness: "Ready"
        },
        {
          id: 102,
          name: "Phase 2 – Sales",
          divisions: "Sales, Marketing",
          fromTo: "Building B → Building C",
          contractor: "Move Consultants",
          people: 80,
          desks: 72,
          assets: 280,
          date: "05 Jun 2025",
          readiness: "Missing Info"
        }
      ]
    }
  ];

  /*
    TOGGLE EXPAND
  */
  function toggleProject(projectId) {
    setExpandedProjectIds(function (prev) {
      if (prev.includes(projectId)) {
        return prev.filter(function (id) {
          return id !== projectId;
        });
      }
      return prev.concat(projectId);
    });
  }

  function isExpanded(projectId) {
    return expandedProjectIds.includes(projectId);
  }

  return (
    <div style={{ padding: "20px", marginLeft:'60px', marginTop:'70px', width:'calc(100% - 10px)'}}>
	<Header />
	 <LeftMenu />
	 <SplitScreenSelector/>
     
		 {/* PAGE TITLE */}
		 <div style={{ marginBottom: "12px" }}>
		   <h2>Projects</h2>
		 </div>

		

      {/* TABLE HEADER */}
      <div style={{ display: "grid", gridTemplateColumns: "2fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr", fontWeight: "bold", padding: "8px 0", borderBottom: "1px solid #ccc" }}>
        <div>Project</div>
        <div>Sponsor</div>
        <div>Company</div>
        <div>Status</div>
        <div>People</div>
        <div>Desks</div>
        <div>Assets</div>
        <div>Moves</div>
        <div>Target</div>
      </div>

	  {/* PROJECT ROWS */}
	  {projects.map(function (project) {
	    var expanded = isExpanded(project.id);

	    return (
	      <div key={project.id}>

	        {/* PROJECT ROW */}
	        <div
	          style={{
	            display: "grid",
	            gridTemplateColumns: "2fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr auto",
	            padding: "10px 0",
	            borderBottom: "1px solid #eee",
	            fontSize: "14px",
	            fontWeight: "normal",
	            background: expanded
	              ? "linear-gradient(180deg, #2F80ED 0%, #0B4F8A 100%)"
	              : "#f9f9f9",
	            color: expanded ? "#ffffff" : "#000000",
	            transition: "background 0.25s ease, color 0.25s ease"
	          }}
	        >
	          {/* Project name + expand */}
	          <div
	            style={{
	              cursor: "pointer",
	              display: "flex",
	              alignItems: "center",
	              gap: "8px"
	            }}
	            onClick={function () {
	              toggleProject(project.id);
	            }}
	          >
	            <FontAwesomeIcon
	              icon={expanded ? faChevronDown : faChevronRight}
	              style={{
	                color: expanded ? "#ffffff" : "rgba(60, 120, 200, 0.65)",
	                fontSize: "12px",
	                width: "16px",
	                height: "16px",
	                transition: "color 0.25s ease",
					paddingLeft:'10px'
	              }}
	            />

	            <span>{project.name}</span>
	          </div>

	          <div>{project.sponsor}</div>
	          <div>{project.company}</div>

	          {/* Status */}
	          <div>
			  <span
			    style={{
			      padding: "4px 8px",
			      borderRadius: "10px",
			      fontSize: "12px",
			      backgroundColor: expanded
			        ? "rgba(255,255,255,0.25)"
			        : getStatusStyle(project.status).backgroundColor,
			      color: "#fff",
			      cursor: "pointer"
			    }}
			    onClick={function (e) {
			      e.stopPropagation();
			      setActiveProject(project);
			      setShowIssuesDrawer(true);
			    }}
			  >
			    {project.status}
			  </span>
	          </div>

	          <div>{project.people}</div>
	          <div>{project.desks}</div>
	          <div>{project.assets}</div>
	          <div>{project.moves.length}</div>
	          <div>{project.completionDate}</div>

	          {/* Project edit */}
	          <div style={{ textAlign: "right", paddingRight: "8px" }}>
	            <FontAwesomeIcon
	              icon={faPen}
	              title="Edit project"
	              style={{
	                cursor: "pointer",
	                color: expanded ? "#ffffff" : "rgba(0,0,0,0.45)",
	                fontSize: "13px",
	                transition: "color 0.25s ease"
	              }}
	              onClick={function (e) {
	                e.stopPropagation();
	                // open project edit modal
	              }}
	            />
	          </div>
	        </div>

	        {/* MOVE ROWS */}
	        {expanded && project.moves.map(function (move) {
	          return (
	            <div
	              key={move.id}
	              style={{
	                display: "grid",
	                gridTemplateColumns: "2fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr auto",
	                padding: "8px 0 8px 20px",
	                borderBottom: "1px solid #eee",
	                backgroundColor: "#ffffff",
	                fontSize: "14px",
	                fontWeight: "normal"
	              }}
	            >
	              <div>{move.name}</div>
	              <div></div>
	              <div>{move.divisions}</div>
	              <div>{move.contractor}</div>
	              <div>{move.people}</div>
	              <div>{move.desks}</div>
	              <div>{move.assets}</div>
	              <div>{move.date}</div>
	              <div>{move.readiness}</div>

	              {/* Move edit */}
	              <div style={{ textAlign: "right", paddingRight: "8px" }}>
	                <FontAwesomeIcon
	                  icon={faPen}
	                  title="Edit move"
	                  style={{
	                    cursor: "pointer",
	                    color: "rgba(0,0,0,0.35)",
	                    fontSize: "12px"
	                  }}
	                  onClick={function (e) {
	                    e.stopPropagation();
	                    // open move edit modal
	                  }}
	                />
	              </div>
	            </div>
	          );
	        })}

	      </div>
	    );
	  })}
	  {/* ISSUES DRAWER – ALWAYS MOUNTED */}
	  <div
	    style={{
	      position: "fixed",
	      top: "70px",
	      right: "0",
	      width: "420px",
	      height: "calc(100% - 70px)",
	      background: "#1f1f1f",
	      color: "#fff",
	      boxShadow: "-6px 0 18px rgba(0,0,0,0.35)",
	      padding: "20px",
	      zIndex: 1000,

	      /* SLIDE */
	      transform: showIssuesDrawer ? "translateX(0)" : "translateX(100%)",
	      transition: "transform 0.35s ease-out",

	      /* Prevent interaction when hidden */
	      pointerEvents: showIssuesDrawer ? "auto" : "none",
	      willChange: "transform"
	    }}
	  >

	    {/* ONLY render content when project exists */}
	    {activeProject && (
	      <>
	        {/* Header */}
	        <div style={{ marginBottom: "16px" }}>
	          <h3 style={{ margin: 0 }}>{activeProject.name}</h3>
	          <div style={{ fontSize: "12px", opacity: 0.7 }}>
	            Project status & issues
	          </div>
	        </div>

	        {/* Issues */}
	        {activeProject.moves.map(function (move) {
	          return (
	            <div key={move.id} style={{ marginBottom: "18px" }}>
	              <div
	                style={{
	                  fontWeight: 600,
	                  marginBottom: "6px",
	                  borderBottom: "1px solid #444",
	                  paddingBottom: "4px",
	                  marginTop: "30px"
	                }}
	              >
	                {move.name}
	              </div>

	              <div style={{ fontSize: "13px", marginTop: "10px" }}>
	                <div style={{ display: "flex", alignItems: "center", gap: "10px", lineHeight: "22px", color: "lightgrey" }}>
	                  <span style={{ width: 10, height: 10, borderRadius: "50%", background: "#c0392b" }} />
	                  Contractor not confirmed
	                </div>

	                <div style={{ display: "flex", alignItems: "center", gap: "8px", marginTop: "6px", lineHeight: "22px", color: "lightgrey" }}>
	                  <span style={{ width: 10, height: 10, borderRadius: "50%", background: "#f39c12" }} />
	                  Asset survey incomplete
	                </div>

	                <div style={{ display: "flex", alignItems: "center", gap: "8px", marginTop: "6px", lineHeight: "22px", color: "lightgrey" }}>
	                  <span style={{ width: 10, height: 10, borderRadius: "50%", background: "#27ae60" }} />
	                  Rigidity checks complete
	                </div>
	              </div>
	            </div>
	          );
	        })}

	        {/* Close */}
	        <div
	          style={{
	            position: "absolute",
	            top: "16px",
	            right: "16px",
	            cursor: "pointer",
	            fontSize: "18px"
	          }}
	          onClick={function () {
	            setShowIssuesDrawer(false);
	          }}
	        >
	          ✕
	        </div>
	      </>
	    )}
	  </div>


    </div>
  );
}
